import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-3">
            话题标签
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            大家都在聊的热门话题，找到你的同好圈子
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-3xl mx-auto">
          {topicsData.map((item, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`inline-flex items-center gap-1.5 px-4 py-2.5 md:px-5 md:py-3 rounded-full text-sm md:text-base font-medium transition-all duration-300 cursor-pointer no-underline whitespace-nowrap ${
                item.hot
                  ? 'bg-primary-100/80 text-primary-700 hover:bg-primary-200 hover:text-primary-800'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800 border border-background-200/60'
              }`}
            >
              {item.label}
              {item.hot && (
                <i className="ri-fire-line text-xs"></i>
              )}
            </a>
          ))}
        </div>

        <p className="text-center text-xs md:text-sm text-foreground-400 mt-6">
          点击标签探索更多相关漫画内容
        </p>
      </div>
    </section>
  );
}